import { render, staticRenderFns } from "./ManagementSmartTx.vue?vue&type=template&id=1781c8de&scoped=true&"
import script from "./ManagementSmartTx.vue?vue&type=script&lang=ts&"
export * from "./ManagementSmartTx.vue?vue&type=script&lang=ts&"
import style0 from "./ManagementSmartTx.vue?vue&type=style&index=0&id=1781c8de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1781c8de",
  null
  
)

export default component.exports